import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, AlertCircle, Info, X, AlertTriangle } from 'lucide-react';
import { useToast, ToastType } from '../../hooks/useToast';
const icons = {
  success: <CheckCircle className="w-5 h-5 text-green-500" data-id="element-2621" />,
  error: <AlertCircle className="w-5 h-5 text-red-500" data-id="element-2622" />,
  info: <Info className="w-5 h-5 text-blue-500" data-id="element-2623" />,
  warning: <AlertTriangle className="w-5 h-5 text-yellow-500" data-id="element-2624" />
};
const bgColors = {
  success: 'bg-green-50 border-green-100',
  error: 'bg-red-50 border-red-100',
  info: 'bg-blue-50 border-blue-100',
  warning: 'bg-yellow-50 border-yellow-100'
};
export function ToastContainer() {
  const {
    toasts,
    dismiss
  } = useToast();
  return <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-full max-w-sm pointer-events-none px-4 sm:px-0" data-id="element-2625">
      <AnimatePresence data-id="element-2626">
        {toasts.map(t => <motion.div key={t.id} initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9,
        transition: {
          duration: 0.2
        }
      }} layout className={`pointer-events-auto flex items-center p-4 rounded-lg shadow-lg border ${bgColors[t.type]} bg-white`} data-id="element-2627">
            <div className="flex-shrink-0 mr-3" data-id="element-2628">{icons[t.type]}</div>
            <p className="flex-1 text-sm font-medium text-gray-900" data-id="element-2629">
              {t.message}
            </p>
            <button onClick={() => dismiss(t.id)} className="ml-3 flex-shrink-0 text-gray-400 hover:text-gray-600 focus:outline-none" data-id="element-2630">
              <X className="w-4 h-4" data-id="element-2631" />
            </button>
          </motion.div>)}
      </AnimatePresence>
    </div>;
}